import {Chip, Tooltip} from '@mui/material';
import {capitalize} from '@mui/material/utils';
import React from 'react';
import {API_TARGET} from '@app/config';

const APITargetChip = () => {
  if (window.location.hostname === 'www.planet.com') {
    return false;
  }
  const prefix = import.meta.env.DEV ? 'Local' : 'Internal';
  const tooltipText = `Granero: ${import.meta.env.VITE_GRANERO_TARGET}`;
  return (
    <Tooltip title={tooltipText}>
      <Chip
        label={`${prefix} - ${capitalize(API_TARGET)}`}
        color={import.meta.env.DEV ? 'info' : 'secondary'}
      />
    </Tooltip>
  );
};

export default APITargetChip;
